export default __webpack_public_path__ + "static/logo-c2a9b0a8aeac2079e95e7da32fc3331a.svg";